import * as XLSX from 'xlsx-js-style';
import { getColumnsKeys, getRowsKeys } from './keys';

/**
 * Get all used columns count.
 *
 * @param sheet XLSX Sheet object.
 * @returns count of used columns.
 */
export const getColumnsCount = (sheet: XLSX.WorkSheet) => {
  const columnKeys = getColumnsKeys(sheet);
  return columnKeys.length;
};

/**
 * Get all used rows count.
 *
 * @param sheet XLSX Sheet object.
 * @returns count of used rows.
 */
export const getRowsCount = (sheet: XLSX.WorkSheet) => {
  const rowKeys = getRowsKeys(sheet);
  return rowKeys.length;
};
